import React, { useState } from "react";
import "./Home.css";

const Home = ({ today = new Date(), forwardedRef, isHighlighted }) => {
  const [bookingDate, setBookingDate] = useState(null);
  const [error, setError] = useState("");

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleDateChange = (event) => {
    const selectedDateString = event.target.value;
    setBookingDate(null);
    setError("");

    if (selectedDateString) {
      const selected = new Date(selectedDateString);
      const startOfToday = new Date(today);
      startOfToday.setHours(0, 0, 0, 0);

      if (selected < startOfToday) {
        setError("Please select a date from today onwards.");
        return;
      }

      calculateBookingDate(selected);
    }
  };

  const calculateBookingDate = (date) => {
    if (date) {
      const bookingDateTime = new Date(
        date.getTime() - 60 * 24 * 60 * 60 * 1000
      );
      setBookingDate(bookingDateTime);
    } else {
      setBookingDate(null);
    }
  };

  const maxBookingDate = new Date(today.getTime() + 60 * 24 * 60 * 60 * 1000);

  return (
    <div className="home-container">
      <header className="header">
        <h1>IRCTC Ticket Date Calculator</h1>
        <p>
          Plan your journey by calculating the ticket booking date 60 days in
          advance.
        </p>
      </header>

      <main className="main-content">
        <section
          className={`card today-info ${isHighlighted ? "highlight" : ""}`}
          ref={forwardedRef}
        >
          <h2>Today's Booking Information</h2>
          <p>
            Today you can book tickets for a journey up to{" "}
            <strong>{formatDate(maxBookingDate)}</strong>.
          </p>
          <p className="info-text">
            This calculation assumes the train departs from its origin station
            on the same day.
          </p>
        </section>

        <section className="card date-calculator">
          <h2>Calculate Booking Date</h2>
          <div className="input-group">
            <label htmlFor="journeyDate">Enter your journey date:</label>
            <input
              type="date"
              id="journeyDate"
              name="journeyDate"
              onChange={handleDateChange}
              min={today.toISOString().split("T")[0]}
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          {bookingDate && (
            <div className="result">
              {new Date(bookingDate).setHours(0, 0, 0, 0) <
              new Date(today).setHours(0, 0, 0, 0) ? (
                <p className="booking-date-result">
                  Booking started on: {formatDate(bookingDate)}
                </p>
              ) : (
                <>
                  <p>Booking will open on:</p>
                  <h3 className="booking-date-result">
                    {formatDate(bookingDate)} at 08:00 AM IST
                  </h3>
                </>
              )}
            </div>
          )}
        </section>
      </main>

      <footer className="footer">
        <p>
          Book your tickets at the official{" "}
          <a
            href="https://www.irctc.co.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            IRCTC website
          </a>
          .
        </p>
      </footer>
    </div>
  );
};

export default Home;